export const handleErrorAlert = (
    setAlertData,
    message = 'Something went wrong, please try again',
    error = null,
) => {
    let displayMessage = message;
    const status = error?.response?.status;
    const errorMessage = error?.response?.data?.error;

    if (status === 400 && errorMessage) {
        displayMessage = errorMessage;
    }

    setAlertData({
        severity: 'error',
        message: displayMessage,
        open: true,
    });
};
